import { render } from "./VideoPlayerControlsContainer.vue?vue&type=template&id=fcfaa484&scoped=true"
import script from "./VideoPlayerControlsContainer.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsContainer.vue?vue&type=script&lang=js"

import "./VideoPlayerControlsContainer.vue?vue&type=style&index=0&id=fcfaa484&lang=scss&scoped=true"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcfaa484"]])

export default __exports__